/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SET_NO_APPLICATION = 'SET_NO_APPLICATION';
export const REMOVE_APPLICATION = 'REMOVE_APPLICATION';
export const GET_ALL_APPLICATIONS = 'GET_ALL_APPLICATIONS';
export const SET_SELECTED_APPLICATION = 'SET_SELECTED_APPLICATION';
